import { useTranslations } from 'next-intl';
import React from 'react';

import { useFormat } from '@cineamo/ui/src/hooks/formatter/useFormat';

import { IconTicket2_24 } from '@cineamo/ui/src/icons/ic-ticket';

const PreReleaseLayout: React.FC<{ releaseDate: string }> = ({ releaseDate }) => {
    const t = useTranslations();
    const format = useFormat();
    const movieReleaseDate = format.dateTime.formatDate(new Date(releaseDate), {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
    return (
        <div className="my-32 flex flex-col space-y-8 items-center text-center tracking-wide">
            <IconTicket2_24 />
            <div className="text-body-bold-16">
                {t('showtimes-finder.search.pre-release.title', { releaseDate: movieReleaseDate })}
            </div>
            <div className="text-body-12 opacity-70">{t('showtimes-finder.search.pre-release.description')}</div>
        </div>
    );
};

export default PreReleaseLayout;
